import { z } from 'zod'

export const previsionsSearchSchema = z.object({
  storeIds: z.array(z.number().int().positive()).optional().default([]),
  horizon: z.number().int().min(1).max(60).optional().default(12),
  view: z.enum(['calendaire', 'cohorte']).optional().default('calendaire'),
  poolIds: z.array(z.number().int().positive()).optional().default([]),
  seasonality: z.boolean().optional().default(true),
  hybrid: z.boolean().optional().default(true),
  window: z.number().int().min(1).max(24).optional().default(3),
  tab: z.enum(['forecast', 'backtest']).optional().default('forecast'),
})

export type PrevisionsSearch = z.infer<typeof previsionsSearchSchema>
